/**
 * Productpagina-extra's: foto-zoom (dialog), sticky koopbalk op mobiel en
 * "eerder bekeken" via localStorage. Alles progressive enhancement: zonder
 * JS is er geen zoom/sticky/recent, maar werkt de pagina volledig.
 */

/* ===== Foto-zoom ===== */
const zoom = document.querySelector('[data-pdp-zoom]');
if (zoom) {
  const zoomBeeld = zoom.querySelector('[data-pdp-zoom-beeld]');
  const sluit = zoom.querySelector('[data-pdp-zoom-sluit]');

  document.querySelectorAll('[data-pdp-beeld]').forEach((beeld) => {
    beeld.addEventListener('click', () => {
      const bron = beeld.dataset.zoom;
      if (bron) zoomBeeld.src = bron;
      zoom.showModal();
    });
  });

  sluit?.addEventListener('click', () => zoom.close());
  zoom.addEventListener('click', (event) => {
    // Klik op de backdrop (buiten de afbeelding) sluit de lightbox
    if (event.target === zoom) zoom.close();
  });
}

/* ===== Sticky koopbalk (mobiel) ===== */
const sticky = document.querySelector('[data-pdp-sticky]');
const atc = document.querySelector('.pdp__atc');
if (sticky && atc && 'IntersectionObserver' in window) {
  const observer = new IntersectionObserver(
    ([entry]) => {
      const toon = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-zichtbaar', toon);
      sticky.setAttribute('aria-hidden', String(!toon));
      sticky.toggleAttribute('inert', !toon);
    },
    { threshold: 0 }
  );
  observer.observe(atc);
}

/* ===== Eerder bekeken ===== */
const OPSLAG = 'kfl-eerder-bekeken';
const MAX_OPSLAG = 8;
const MAX_TONEN = 4;

try {
  const huidigEl = document.querySelector('[data-recent-product]');
  const sectie = document.querySelector('[data-recent-bekeken]');
  const grid = document.querySelector('[data-recent-grid]');
  if (huidigEl && sectie && grid) {
    const huidig = JSON.parse(huidigEl.textContent);
    const lijst = JSON.parse(localStorage.getItem(OPSLAG) || '[]');

    // Toon eerdere producten (zonder het huidige), daarna huidig vooraan bewaren
    const anderen = lijst.filter((p) => p.handle !== huidig.handle).slice(0, MAX_TONEN);
    if (anderen.length > 0) {
      for (const p of anderen) {
        const kaart = document.createElement('article');
        kaart.className = 'product-card card card--lift';
        const beeld = p.beeld
          ? `<img src="${p.beeld}" alt="" loading="lazy">`
          : '';
        kaart.innerHTML = `
          <a href="${p.url}" class="product-card__link">
            <div class="product-card__media">${beeld}</div>
            <div class="product-card__info">
              ${p.merk ? `<span class="product-card__vendor"></span>` : ''}
              <h3 class="product-card__title"></h3>
              <span class="price"><span class="price__current"></span></span>
            </div>
          </a>`;
        // Tekst via textContent: nooit rauwe HTML uit opslag injecteren
        if (p.merk) kaart.querySelector('.product-card__vendor').textContent = p.merk;
        kaart.querySelector('.product-card__title').textContent = p.titel;
        kaart.querySelector('.price__current').textContent = p.prijs;
        grid.append(kaart);
      }
      sectie.hidden = false;
    }

    const nieuweLijst = [huidig, ...lijst.filter((p) => p.handle !== huidig.handle)].slice(0, MAX_OPSLAG);
    localStorage.setItem(OPSLAG, JSON.stringify(nieuweLijst));
  }
} catch {
  /* localStorage niet beschikbaar (privémodus): stil overslaan */
}
